import { CheckCircle2 } from 'lucide-react';

const VALUES = [
    'Client-first philosophy in every recommendation',
    'Long-term wealth creation over short-term noise',
    'Financial discipline, transparency and honest fees',
    'Personalised, goal-based guidance for families',
];

export default function About() {
    return (
        <section id="about" className="section-pad bg-white">
            <div className="container-wl grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                <div className="lg:col-span-5">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="gold-rule" />
                        <span className="overline">About Waylthlane</span>
                    </div>
                    <h2 className="font-display-bold text-ink text-4xl lg:text-[52px] leading-[1.05] tracking-tight">
                        Quiet, disciplined wealth — built for the long arc of your life.
                    </h2>
                </div>

                <div className="lg:col-span-7 space-y-6 text-ink/75 text-[16.5px] leading-relaxed">
                    <p>
                        Waylthlane Financials is a Ghaziabad-based advisory firm built on a simple idea:
                        good money decisions should feel calm, not chaotic. We sit on your side of the
                        table — listening first, planning second, and only then talking about products.
                    </p>
                    <p>
                        With{' '}
                        <strong className="text-ink">62+ years of combined practitioner experience</strong>{' '}
                        and over 500 households served, our team blends deep technical understanding with
                        a quiet, fiduciary mindset. We help you build a written plan, stay disciplined
                        through cycles, and grow wealth that actually reaches your life goals.
                    </p>

                    <ul className="pt-2 grid sm:grid-cols-2 gap-x-8 gap-y-4">
                        {VALUES.map((v) => (
                            <li key={v} className="flex items-start gap-3">
                                <CheckCircle2 className="w-5 h-5 text-forest shrink-0 mt-0.5" />
                                <span className="text-[15px] text-ink/85">{v}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
